import { IAction, isType } from '@zaibot/fsa';
import SortingMethod from '../filter/SortingMethod';

import LOGGEDOUT from '../../auth/actions/LOGGEDOUT';
import READY from '../../browser/actions/READY';
import PAGEFILTER_CHANGE_CATEGORY from './actions/CHANGE_CATEGORY';
import PAGEFILTER_CHANGE_SORTING from './actions/CHANGE_SORTING';
import PAGEFILTER_HIDE from './actions/HIDE';
import PAGEFILTER_SHOW from './actions/SHOW';
import PAGEFILTER_TOGGLE_CATEGORY from './actions/PAGEFILTER_TOGGLE_CATEGORY';
import PAGEFILTER_TOGGLE_SORTING from './actions/PAGEFILTER_TOGGLE_SORTING';

interface IState {
  categoryId: number;
  categoryvisible: boolean;
  sorting: SortingMethod;
  visible: boolean;
}
const emptyState: IState = {
  categoryId: undefined,
  categoryvisible: false,
  sorting: 'createdDesc',
  visible: false,
};
export const selector = (state: any) => state.pageFilter as IState;

export const reducer = (state = emptyState, action: IAction) => {
  if (isType(action, PAGEFILTER_SHOW)) {
    return { ...state, visible: true };
  }
  if (isType(action, PAGEFILTER_HIDE)) {
    return { ...state, visible: false };
  }
  if (isType(action, PAGEFILTER_CHANGE_CATEGORY)) {
    return { ...state, categoryId: action.payload.categoryId };
  }
  if (isType(action, PAGEFILTER_TOGGLE_CATEGORY)) {
    return { ...state, categoryId: action.payload.categoryId };
  }    
  if (isType(action, PAGEFILTER_CHANGE_SORTING)) {
    return { ...state, sorting: action.payload.sorting };
  }
  if (isType(action, PAGEFILTER_TOGGLE_SORTING)) {
    return { ...state, sorting: action.payload.sorting };
  }  
  if (isType(action, READY)) {
    return { ...state, visible: false };
  }
  if (isType(action, LOGGEDOUT)) {
    return { ...state, visible: false };
  }
  return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/pageFilter/reducer.tsx